import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=5b2f89d8&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=ts"
export * from "./CopyButton.vue?vue&type=script&lang=ts"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=5b2f89d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f89d8",
  null
  
)

export default component.exports